module.exports = __webpack_public_path__ + "assets/img/d49726d0381f22d531dbd50d02e6ecb4.svg";